import React from 'react';
import { useNavigate } from 'react-router-dom';
import { validateForm } from '../../../../../utils/validation';

const FormList = ({activeStep, setActiveStep, formData}) => {
  const navigate = useNavigate();

  const isFormSectionComplete = (sectionId) => {
    if (!formData) return false;

    switch (sectionId) {
      case 'medical': {
        // For completion status on the list, consider only mandatory fields
        const errors = validateForm(formData, 'medical', true);
        return errors && Object.keys(errors).length === 0;
      }
      case 'emergency': {
        const errors = validateForm(formData, 'emergency', false);
        return Array.isArray(errors) ? errors.length === 0 : true;
      }
      case 'contact': {
        const errors = validateForm(formData, 'contact', false);
        return errors && Object.keys(errors).length === 0;
      }
      case 'payment':
        return Boolean(formData?.status === 'Paid');
      default:
        return false;
    }
  };

  const noFormFound = !formData || !formData._id;

  const formSections = [
    {
      id: 'medical',
      title: 'Medical Information',
      description: 'Information regarding your condition and health'
    },
    {
      id: 'emergency',
      title: 'Emergency Contact',
      description: 'Person to be contacted in case of medical emergency'
    },
    {
      id: 'contact',
      title: 'Contact Details',
      description: 'Home address & email details in case the card is lost'
    },
    {
      id: 'payment',
      title: 'Payment Details',
      description: 'Mode of payment & Order placed'
    }
  ];

  const handleFormClick = (id) => {
    setActiveStep(id);
    // Scroll to top when changing forms
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      <div className="space-y-4">
        {formSections.map((section) => (
          <div
            key={section.id}
            className={`rounded-lg border border-[2px] m-6 p-6 ${isFormSectionComplete(section.id) ? 'bg-[#e0d3ee]' : 'bg-[#FFFFFF]'} text-[#753ABF] relative flex items-center justify-between border-[#753ABF]`}
          >
            <div className="flex justify-between items-center w-full">
              <div>
                <h3 className="text-[#753ABF] text-lg font-semibold mb-1">{section.title}</h3>
                <p className="text-[#753ABF]/70 text-sm">{section.description}</p>
              </div>
              <div className='flex flex-col justify-between items-end'>
                {isFormSectionComplete(section.id) && (
                  <div className="inline-flex items-center px-4 py-2 rounded-md text-sm font-medium bg-[#753ABF] text-[#FFFFFF] mb-2">
                    Completed
                  </div>
                )}
                <button 
                  className={`w-fit flex items-center justify-center px-6 py-1 rounded-md text-sm font-bold mt-2 ${
                    section.id === 'payment' && ((formData.status === 'Saved' || formData.status === 'Submitted') || noFormFound)
                      ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                      : 'bg-[#cde8f8] text-[#753ABF]'
                  }`}
                  onClick={() => {
                    if (section.id === 'payment' && ((formData.status === 'Saved' || formData.status === 'Submitted') || noFormFound)) {
                      return;
                    }
                    handleFormClick(section.id);
                  }}
                  title={section.id === 'payment' && (formData.status === 'Saved' || formData.status === 'Submitted') ? 'Form must be verified before accessing payment details' : (section.id === 'payment' && noFormFound ? 'Create and save your form before accessing payment details' : '')}
                  disabled={section.id === 'payment' && ((formData.status === 'Saved' || formData.status === 'Submitted') || noFormFound)}
                >
                  View <img className={`mt-[3px] ${section.id === 'payment' && ((formData.status === 'Saved' || formData.status === 'Submitted') || noFormFound) ? 'opacity-50' : ''}`} src="/Assets/Images/viewButtonIcon.svg" alt="" aria-hidden="true" role="presentation" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormList;
